import { ArrowUpDown, Eye } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../../components/DataTable";
import { Badge } from "../../../components/ui/badge";
import { Button } from "../../../components/ui/button";
import DialogDeleteGroups from "./DialogDeleteGroups";
import { GroupLang } from "../../../lib/languages";
import { useLanguage } from "../../../context/LanguageContext";
import { useAuth } from "../../../context/AuthContext";

const TableGroups = ({ data, levels, getAllGroups }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";

  const { language } = useLanguage();
  const t = GroupLang[language] || GroupLang["en"];

  const columns = [
    {
      accessorKey: "name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.name}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) => row.original.name || "---",
    },
    {
      accessorKey: "teacher.name",
      header: t.teacher,
    },
    {
      accessorKey: "student_count",
      header: t.studentCount,
      cell: ({ row }) => row.original.users_id?.length || "---",
    },
    {
      accessorKey: "type",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.type}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) => {
        const status = row.getValue("status");
        return (
          <Badge variant={status ? "default" : "outline"}>
            {status ? t.groups : t.individual}
          </Badge>
        );
      },
    },
    {
      id: "actions",
      header: t.actions,
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="flex items-center gap-2">
            <Button
              size="icon"
              className="rounded-xl h-9"
              onClick={() =>
                navigate(
                  isAdmin
                    ? `/admin/lessons/${item.id}`
                    : `/teacher/lessons/${item.id}`
                )
              }
            >
              <Eye />
            </Button>
            <DialogDeleteGroups
              lesson={item}
              level={levels}
              getAllGroups={getAllGroups}
            />
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data || []}
      title={t.studyEnrollTitle}
      filterNames={["title_ar", "title_en"]}
    />
  );
};

export default TableGroups;
